import React, { useLayoutEffect, useState } from "react";
import SnpComponent from "../global/SnpComponent";
import {
    useSelector } from "react-redux";
import CustomDataGrid from "../global/CustomDataGrid";
import {
  BILLNUMBERNAME,
  CART_INITIAL_STATE,
  GETSINGLECONFIGS,
  INITIAL_PAGEMODEL,
  InternalBillType,
  PAGINATIONNFILTER,
  SHOWALLBILLS,
  SUCCESS,
  getPreUrlAccordingToCart,
  isEmpty,
  isRoleAllowed,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  OTHER_SALES_RIGHTS
} from "../../constants/constant";
import OpenInNewIcon from '../ui/icons/OpenInNew';
import { Box, Grid, Paper, Typography } from "../ui";
import axios from "axios";
import { snpAxios } from "../global/api";
import { useNavigate } from "react-router-dom";
import ShowBillsFilterPanel from "./ShowBillsFilterPanel";


export default function ShowBills() {
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();
    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        gui: "",
    };
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const [paginationWay, setPaginationWay] = useState("client");
    const [billNumberPrefix, setBillNumberPrefix] = useState("Bill-");


    const handleSnpDialogClose = () => {
        setSnpComponent(INITIAL_SNP_COMPONENT);
    };

    const handleSnackClose = () => {
        setSnpComponent({
            ...snpComponent,
            snackBarOpen: false,
            snackBarMsg: "",
        });
    };

    const handleSnpCancel = () => {
        //console.log("handleSnpCancel");
        if (snpComponent.requestType === 1)
            handleSnpDialogClose();
        else
            navigate("/dashboard");
    };





    const [todayMinus10, setTodayMinus10] = useState('?');
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const [listBills, setShowBills] = useState([]);

    const handleCellClick = (param, event) => {
        console.log("handleCellClick : ", event.row);
        if (event.row.billType === InternalBillType.RETURN_BILL
            || event.row.billType === InternalBillType.WASTE_BILL
        )
            navigate("/dashboard/returnwastebill", {
                state: { sBillNo: event.row.billNo },
                replace: true
            });
        else
            navigate("/dashboard/billentry", {
                state: { tableProps: {}, sBillNo: event.row.billNo, billType: -1, isSearchByShowBills: true },
                replace: true
            });
    };


    const [paginationModel, setPaginationModel] = useState(INITIAL_PAGEMODEL);

    const getAllBillDetails = async (mPage, mPageSize, data, pWay) => {
        //console.log("getAllBillDetails=> ",pageData);
        setSnpComponent({
            ...snpComponent,
            isLoader: true,
        });
        let url = storeApiUrl.BACKEND_BASE_URL + SHOWALLBILLS;
        if (pWay === "server")
            url = url + "/" + mPage + "/" + mPageSize;

        //console.log("getAllBillDetails  => ", url, data);
        snpAxios.post(
            url,
            data
        )
            .then((response) => {
                //console.log("response  => ", response.data);
                if (response.data.status === SUCCESS) {
                    setSnpComponent({
                        ...snpComponent,
                        isLoader: false,
                    });
                    setShowBills(response.data.jcJson.data);
                    setTodayMinus10(response.data.jcJson.todaysMinus10);
                    setPaginationModel({
                        ...paginationModel,
                        page: mPage,
                        pageSize: mPageSize,
                        rowCount: response.data.jcJson.totalRecords,
                    });
                } else if (Object.keys(data?.jcJson || {}).some(key => key.startsWith("f"))) {
                    setShowBills([]);
                    setPaginationModel(prev => ({
                        ...prev,
                        page: 0,
                        rowCount: 0,
                    }));
                    setSnpComponent(prev => ({
                        ...prev,
                        isLoader: false,
                    }));
                } else {
                    setSnpComponent({
                        ...snpComponent,
                        isLoader: false,
                        negativeReq: true,
                        negativeAction: "Home",
                        showDialog: true,
                        positiveReq: true,
                        positiveAction: "Dismiss",
                        outSideClickDismiss: false,
                        cancelExtra: true,
                        requestType: 2,
                        subTitle: "No Sales Available,Go Home"
                    });
                }
            }).catch((error) => {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Home",
                    positiveReq: true,
                    positiveAction: "Dismiss",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 2,
                    subTitle: { error }
                });
                console.log("errr ", error);
                //window.location.href = "#/error";
            });
    };
    const getSingleConfigs = (mConfigName) => {
        const cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETSINGLECONFIGS + `?adminId=${CART_INITIAL_STATE.apiToken}`
            + `&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
        let data = {};
        //const urlFormattedString = encodeURIComponent(cUrl);
        //printLog("getSingleConfigs => ", cUrl);
        axios.get(
            cUrl,
            data
        )
            .then((response) => {
                //printLog("getSingleConfigs<=",response.data);
                if (response.data !== '') {
                    if (mConfigName === PAGINATIONNFILTER) {
                        setPaginationWay(response.data);
                        handleFilterQuery(paginationModel.page, paginationModel.pageSize, null, response.data);
                    } else if (mConfigName === BILLNUMBERNAME) {
                        setBillNumberPrefix(response.data);
                    }
                }
            }).catch((error) => {
                //printLog("error : ", error);
                //window.location.href = "#/error";
                if (mConfigName === PAGINATIONNFILTER)
                    handleFilterQuery(paginationModel.page, paginationModel.pageSize, null, paginationWay);
            });
    };

    useLayoutEffect(() => {
        //console.log('useLayoutEffect : ', CART_INITIAL_STATE, storeActiveShopHash);
        getSingleConfigs(PAGINATIONNFILTER);
        getSingleConfigs(BILLNUMBERNAME);
    }, [storeActiveShopHash, storeApiUrl]);

    const statusColumn = {
        field: 'billStatusId',
        headerName: 'Status',
        width: 90,
        filterable: true,
        renderCell: (cellValues) => cellValues.row.billStatusId === "Rejected" ? (
            <Typography
                component="button"
                type="button"
                onClick={() => setSnpComponent(prev => ({
                    ...prev,
                    showDialog: true,
                    title: "Rejection Reason",
                    subTitle: "Rejected By Owner",
                    gui: <Box sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", color: "#b42318", fontWeight: 700 }}>
                        {cellValues.row.reason || "No reason provided"}
                    </Box>,
                    positiveReq: true,
                    positiveAction: "Close",
                    negativeReq: false,
                    requestType: 1,
                }))}
                sx={{ border: 0, background: "transparent", color: "#b42318", fontWeight: 700, textDecoration: "underline", cursor: "pointer" }}>
                Rejected
            </Typography>
        ) : cellValues.row.billStatusId,
    };




    const columns = [
        {
            field: "view",
            headerName: "View",
            width: 20,
            renderCell: (cellValues) => {
                return (
                    <OpenInNewIcon
                        onClick={(event) => {
                            //console.log("event.row",cellValues.row.billAddBy , CART_INITIAL_STATE.userName)
                            if (!isEmpty(cellValues.row.billAddBy) && cellValues.row.billAddBy !== CART_INITIAL_STATE.userName) {
                                if (isOtherRoleAllowed(OTHER_SALES_RIGHTS)) {
                                    handleCellClick(event, cellValues);
                                } else {

                                    setSnpComponent({
                                        ...snpComponent,
                                        isLoader: false,
                                        negativeReq: true,
                                        negativeAction: "Got It!",
                                        showDialog: true,
                                        outSideClickDismiss: false,
                                        cancelExtra: true,
                                        requestType: 1,
                                        subTitle: "You Are not allowed to Change in Sales.Contact the Owner"
                                    });
                                }
                            } else {
                                handleCellClick(event, cellValues);
                            }

                        }}
                    ></OpenInNewIcon>
                );
            },
        },
        { field: 'billNo', headerName: 'BillNo.', width: 150 },
        { field: 'billAddBy', headerName: 'Sale Person', width: 140 },
        { field: 'type', headerName: 'Type', width: 130 },
        { ...statusColumn, filterable: false },
        { field: 'finalPrice', headerName: 'F.Price', width: 80 },
        { field: 'cust', headerName: 'Cust.', width: 180 },
        { field: 'createdAt', headerName: 'On', width: 150 },
        { field: 'royalityPoint', headerName: 'R.Point', width: 60 },
    ];

    const columnsAdmin = [
        {
            field: "view",
            headerName: "View",
            width: 20,
            filterable: false,
            renderCell: (cellValues) => {
                return (
                    <OpenInNewIcon
                        onClick={(event) => {
                            //console.log("event.row",cellValues.row.billAddBy , CART_INITIAL_STATE.userName)
                            if (!isEmpty(cellValues.row.billAddBy) && cellValues.row.billAddBy !== CART_INITIAL_STATE.userName) {
                                if (isOtherRoleAllowed(OTHER_SALES_RIGHTS)) {
                                    handleCellClick(event, cellValues);
                                } else {

                                    setSnpComponent({
                                        ...snpComponent,
                                        isLoader: false,
                                        negativeReq: true,
                                        negativeAction: "Got It!",
                                        showDialog: true,
                                        outSideClickDismiss: false,
                                        cancelExtra: true,
                                        requestType: 1,
                                        subTitle: "You Are not allowed to Change in Sales.Contact the Owner"
                                    });
                                }
                            } else {
                                handleCellClick(event, cellValues);
                            }

                        }}
                    ></OpenInNewIcon>
                );
            },
        },
        { field: 'type', headerName: 'Type', width: 190, filterable: true },
        {
            field: 'billNo', headerName: 'BillNo.', width: 150,
            filterable: true
        },
        { field: 'billAddBy', headerName: 'Sale Person', width: 140, filterable: true },
        statusColumn,
        { field: 'finalPrice', headerName: 'F.Price', width: 80, filterable: true },
        { field: 'cust', headerName: 'Cust.', width: 180, filterable: true },
        { field: 'generateOtp', headerName: 'Gen.Bill OTP', width: 110, filterable: false },
        { field: 'createdAt', headerName: 'On', width: 150, filterable: true }, //,type: 'date'
        { field: 'royalityPoint', headerName: 'R.Point', width: 60, filterable: false },
    ];

    const headerNameList = [
        { key: 'billNo', value: 'Bill Number' },
        { key: 'type', value: 'Bill Type' },
        { key: 'billAddBy', value: 'Sale Person' },
        { key: 'billStatusId', value: 'Bill Status' },
        { key: 'finalPrice', value: 'Final Price' },
        { key: 'cust', value: 'Customer Name or Mobile' },
        { key: 'createdAt', value: 'Created On' },
    ];

    const INITIAL_FILTERS = [{ key: headerNameList[0].key, value: "" }];
    const [filters, setFilters] = useState(INITIAL_FILTERS);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const getActiveFilters = (filterData = filters) => filterData
        .filter(filter => !isEmpty(String(filter.value || "").trim()));

    const handleFilterQuery = (mPage, mPageSize, filterData, pWay) => {
        const requestedFilters = filterData == null ? [] : getActiveFilters(filterData);
        const jcJson = {
            shopHash: storeActiveShopHash.id,
            value: CART_INITIAL_STATE.apiToken,
            myBillRequest: !(isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) || isOtherRoleAllowed(OTHER_SALES_RIGHTS)),
        };

        requestedFilters.forEach(filter => {
            const requestKey = 'f' + filter.key[0].toUpperCase() + filter.key.slice(1);
            jcJson[requestKey] = filter.key === 'billNo'
                ? `${billNumberPrefix}${filter.value}`
                : filter.value;
        });

        if (filterData == null) {
            setFilters(INITIAL_FILTERS);
            setAppliedFilters([]);
        } else {
            setAppliedFilters(requestedFilters);
        }

        getAllBillDetails(mPage, mPageSize, { jcJson }, pWay);
    }
    const renderSnpContent = () => {
        return (
            <React.Fragment>
                <Grid container spacing={3}>
                    {paginationWay === 'client' &&
                        <Grid item md={12} sm={12} xs={12} lg={12}>
                            <Paper elevation={0} sx={{ px: 1.5, py: 1, borderRadius: 1.5, backgroundColor: "rgba(47, 17, 96, 0.08)" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
                                    <Typography variant="body2" style={{ color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                                        {"Showing bills from " + todayMinus10 + " onward. For older bills, generate the Sales Report from Owner Dashboard."}
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>
                    }
                    <Grid item md={12} sm={12} xs={12} lg={12}>
                        <ShowBillsFilterPanel
                            fields={headerNameList}
                            filters={filters}
                            billNumberPrefix={billNumberPrefix}
                            loading={snpComponent.isLoader}
                            onChange={setFilters}
                            onApply={() => handleFilterQuery(0, paginationModel.pageSize, filters, paginationWay)}
                            onClear={() => handleFilterQuery(0, paginationModel.pageSize, null, paginationWay)}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                        <CustomDataGrid
                            key={`${paginationWay}-${JSON.stringify(appliedFilters)}`}
                            getRowId={row => row.billNo}
                            rows={listBills}
                            loading={snpComponent.isLoader}
                            columns={isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) ? columnsAdmin : columns}
                            mDensity="compact"
                            paginationMode={paginationWay}
                            paginationModel={paginationModel}
                            onPageDataChange={(e) => handleFilterQuery(e, paginationModel.pageSize, appliedFilters, paginationWay)}
                            cbPageSizeChange={(mPageSize) => handleFilterQuery(0, mPageSize, appliedFilters, paginationWay)}
                            mDisableColumnFilter
                            hideToolbarFilter
                        />
                    </Grid></Grid>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                handleDialogClose={handleSnpDialogClose}
                handleSubmit={handleSnpDialogClose}
                iconReq={snpComponent.iconReq}
                gui={snpComponent.gui}
                content={renderSnpContent()}
                onSnackClose={handleSnackClose}
                cancelExtra={snpComponent.cancelExtra}
                onCancel={handleSnpCancel}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </React.Fragment>
    );
};
